<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["history"] }}</p>
      </div>
      <p class="content_title" v-if="places.length > 0">
        {{ vehicleName.toUpperCase() }}
      </p>
      <p class="content_title" v-if="places.length <= 0">
        {{ this.$store.getters.TRANSLATIONS["no_history_yet"] }}
      </p>
      <div
        class="car"
        v-for="item in places"
        :key="item.id"
        v-on:click="next(item)"
      >
        <div class="model">
          <button class="button">
            {{
              moment(String(item.createdAt)).format("MM/DD/YYYY hh:mm") || ""
            }}
            {{ item.name || "" }} >
          </button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.vehicleId = this.$store.getters.USER.historySelectedVehicleId;
      this.places =
        this.$store.getters.USER.vehicles[
          this.$store.getters.USER.vehicles.findIndex(
            (v) => v.id === this.vehicleId
          )
        ].places;
      this.vehicleName =
        this.$store.getters.USER.vehicles[
          this.$store.getters.USER.vehicles.findIndex(
            (v) => v.id === this.vehicleId
          )
        ].make +
        " " +
        this.$store.getters.USER.vehicles[
          this.$store.getters.USER.vehicles.findIndex(
            (v) => v.id === this.vehicleId
          )
        ].model;
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      places: [],
      vehicleId: null,
      vehicleName: "",
      next: (item) => {
        if (
          !this.$store.getters.USER.vehicles[
            this.$store.getters.USER.vehicles.findIndex(
              (v) => v.id === this.vehicleId
            )
          ].places[
            this.$store.getters.USER.vehicles[
              this.$store.getters.USER.vehicles.findIndex(
                (v) => v.id === this.vehicleId
              )
            ].places.findIndex((p) => p.id === item.id)
          ].details
        ) {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$http
            .get(
              `${process.env.SERVER_URL}/E5913C04871E48E9BF4466FEF3FA05A5/${item.id}`,
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Get vehicle place details response:");
              console.log(response);
              let User = this.$store.getters.USER;
              User.vehicles[
                User.vehicles.findIndex((v) => v.id === this.vehicleId)
              ].places[
                User.vehicles[
                  User.vehicles.findIndex((v) => v.id === this.vehicleId)
                ].places.findIndex((p) => p.id === item.id)
              ].details = response.data;

              User.historySelectedPlaceId = item.id;
              this.$store.dispatch("SAVE_USER", User);
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.error
              ) {
                text = error.response.data.error;
              }
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      this.$storage.remove("parkendaToken");
                      this.$router.push("/login");
                    }
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
              this.$router.push("/historyVehiclePlaceDetails");
            });
        } else {
          let User = this.$store.getters.USER;
          User.historySelectedPlaceId = item.id;
          this.$store.dispatch("SAVE_USER", User);
          this.$router.push("/historyVehiclePlaceDetails");
        }
      },
      back: () => {
        this.$router.push("/historyVehicles");
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.button {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/History/Places.vue